module.exports = __webpack_public_path__ + "img/coding.3eea6c0d.png";